import { Typography } from "@material-ui/core"
import styled from "styled-components"

const StyledContainer = styled("div")`
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ffbc0d;
  background: #fffaeb;
  width: fit-content;
  min-height: 36px;
`

const StyledText = styled(Typography)`
  color: #000;
  font-family: NarkisBlock;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.27px;
  display: flex;
  align-items: center;
`

type DiscountPromoType = {
  promoText: string
}

const DiscountPromo = ({ promoText }: DiscountPromoType) => {
  return (
    <StyledContainer>
      <StyledText>{promoText}</StyledText>
    </StyledContainer>
  )
}

export default DiscountPromo
